import React from "react";

import Attendance from "components/attendance";
import { Wraps } from "components/layout";
import { localizeIt } from "components/service/localize";
import { useMe, useVarParam } from "components/use-hooks";


const MyTimeRecordsPage = () => {
    const { me } = useMe();
    const appParams = useVarParam();

    appParams.set({
        headerTitle: localizeIt("PAGE.Title_MyTimeRecords"),
        bottomBar: true,
        searchOn: false
    });

    return (
        <Wraps.Container className="page attendance-time-records-page">
            <Attendance.Lists.TimeRecords
                eeId={ me.eeCurrentId }
                moment={ appParams.get("moment") }
            />
        </Wraps.Container>
    );
};

export default MyTimeRecordsPage;
